import clsx from "clsx";
import React, { ElementType, ReactNode, Ref, forwardRef } from "react";

import {
  PolymorphicComponent,
  PolymorphicComponentProps,
} from "../PolymorphicComponent";

type SectionProps = {
  children: ReactNode;
  className?: string;
};

const defaultElement = "section";

export type SectionConfig<E extends ElementType = typeof defaultElement> =
  PolymorphicComponentProps<E, Partial<SectionProps>>;

export const createSection = <
  Element extends ElementType = typeof defaultElement
>({
  className: configClassName,
  element: configElement,
}: SectionConfig<Element>): PolymorphicComponent<Element, SectionProps> => {
  const Section = forwardRef(
    <E extends ElementType = Element>(
      {
        children,
        className = configClassName,
        element,
      }: PolymorphicComponentProps<E, SectionProps>,
      ref: Ref<Element>
    ) => {
      const Tag: ElementType = configElement || element || defaultElement;

      return (
        <Tag className={clsx("tw-section", className)} ref={ref}>
          {children}
        </Tag>
      );
    }
  ) as PolymorphicComponent<Element, SectionProps>;

  Section.displayName = "TWSection";
  return Section;
};
